import { NextFetch } from '@/utils/request';
import host from '@/utils/request/host';

interface Params {
  shopId?: number; // 门店id
  seriesId?: number; // 车系id
}

export interface SeriesResult {
  albums?: []; // 车系轮播图
  brandName?: string; // 品牌名称
  imgCount?: number; // 图片数量
  minPrice?: number; //最低售价
  maxPrice?: number; // 最高售价
  seriesName?: string; // 车系名称
  priceUnit?: string; // 价格单位
  onSaleSpecCount?: number; // 车型数量
  textImgList?: string[]; // 图文详情
  buyCalCopy?: string; // 购车计算文案
  slogan?: string; // 宣传标语
  subhead?: string; // 副标题
  tags?: string[]; // 标签列表
}
export async function getCarDeatil(params?: Params) {
  try {
    return await NextFetch.get<SeriesResult>(`${host.mcar}/h5/shopOfficialWebsite/seriesDetail`, params);
  } catch(error: unknown) {
    console.log(error)
    return {};
  }
}

export interface CarSourceItem {
  /**
   * 车系id
   */
  seriesId?: number;
  /**
   * 资源地址
   */
  url: string;
  /**
   * 资源名
   */
  name?: string;
  /**
   * 类型 1轮播图 2视频 3图文详情 4vr
   */
  type?: string;
  /** 创建时间 */
  createTime?: number;
}

export interface CarVideoItem {
  id: number;
  title: string;
  slogan: string;
  videoUrl: string;
  templateUrl: string;
  shortUrl: string;
  brandId: number;
  brandName: string;
  seriesId: number;
  seriesName: string;
  createUser: string;
}
export interface CarPosterItem {
  id: number;
  type: number;
  title: string;
  summary: string;
  previewUrl: string;
  slogan: string;
  templateUrl: string;
  width: number;
  height: number;
  url: string;
}

export interface CarArticleItem {
  id: number;
  title: string;
  imageUrl: string;
  createTime: number;
  sourceUrl: string; //文章地址
  sourceName: string;
  content: string;
  view: number;
  share: number;
  originalAuthor: string;
}
export interface CarQuestionsItem {
  id: number;
  seriesId: number;
  seriesName: string;
  question: string;
  answer: string;
}
export async function getCarSourceListApi(params?: { seriesId: number; type: number }) {
  try {
    return await NextFetch.get<CarSourceItem[]>(`${host.oop}/h5/common/series/source/list`, params);
  } catch(error: unknown) {
    console.log(error);
    return [];
  }
}
export async function getCarVideoApi(params?: { seriesId: number; shopId: number }) {
  return await NextFetch.get<CarVideoItem[]>(`${host.mkt}/h5/website/shop/video/list`, params);
}
export async function getCarPosterApi(params?: { seriesId: number; shopId: number }) {
  return await NextFetch.get<CarPosterItem[]>(`${host.mkt}/h5/website/shop/poster/list`, params);
}
export async function getCarNewsApi(params?: { seriesId: number; shopId: number }) {
  return await NextFetch.get<CarArticleItem[]>(`${host.mkt}/h5/website/shop/new/list`, params);
}
export async function getCarQuestionsApi(params?: { seriesId: number; shopId: number }) {
  return await NextFetch.get<CarQuestionsItem[]>(`${host.mkt}/h5/website/shop/qa/list`, params);
}
